import { Box, Link, Typography } from '@mui/material'
import React from 'react'

function RDCard({ recentDevelopment }) {
  return (
    <Box sx={{ width: { xs: '80vw', md: '35vw', mdlg: '27vw', lg: '20vw' }, height: '30vh', display: 'flex', flexDirection: 'column', gap: 1, p: 2, borderRadius: '10px', background: 'linear-gradient( rgba(36, 36, 36, 0.9))', }} >
      <Typography variant='h6' sx={{ height: '40%', fontWeight: '600', fontSize: '1rem' }} ><Link href={recentDevelopment.url} target="_blank" sx={{ textDecoration: 'none', color: '#55d6aa' }} >{recentDevelopment.title}</Link></Typography>
      <Typography sx={{ height: '50%', fontSize: '0.8rem', color: '#fff' }} >{recentDevelopment.description}</Typography>
      <Box sx={{ height: '10%', textAlign: 'right' }} >
        <Typography sx={{ fontSize: '0.8rem', color: '#fff' }} >{recentDevelopment.date}</Typography>
      </Box>
    </Box>
  )
}

export default RDCard